import { RedirectTypes } from '../types/RedirectTypes';
import { ValueTypes } from '../types/ValueType';
import { LinkValueLookupMap } from './LinkValueLookupMap';

export type RequiresQuickLinkTemplateProperties = { parent: string; node: string; value: any };

const buildValidationMapKey = (property: RequiresQuickLinkTemplateProperties): string => {
  return `${property.parent}-${property.node}`;
};

const getLinkValueForRequiredProperty = (property: RequiresQuickLinkTemplateProperties, link: any): any => {
  const key = buildValidationMapKey(property);
  switch (property.parent) {
    case 'nameLinkTemplate':
    case 'analyticsTags':
    case 'socialMediaTags':
      // @ts-ignore
      return LinkValueLookupMap[key](link);
    case 'redirects':
      return LinkValueLookupMap[property.parent + '-'](property.node, link);
    case 'linkData':
      return LinkValueLookupMap[property.parent + '-'](property.value.fieldName, link);
  }
};

const validateLinkForRequiredProperty = (property: RequiresQuickLinkTemplateProperties, link: any): boolean => {
  const linkValue = getLinkValueForRequiredProperty(property, link);
  const { redirectType, valueType, value: templateValue } = property.value;
  switch (valueType) {
    case ValueTypes.ANY:
    case ValueTypes.SUGGESTIONS:
      return !!linkValue;
    case ValueTypes.FIXED:
      // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
      return redirectType?.toLowerCase() == RedirectTypes.Default?.toLowerCase() ? true : linkValue == templateValue;
    case ValueTypes.CHOOSE:
      return templateValue.includes(linkValue);
    case ValueTypes.EMPTY:
      return !linkValue;
    case ValueTypes.APP_WIDE_DEFAULT:
    default:
      return true;
  }
};

export class QuickLinkTemplateValidation {
  private requiredProperties: RequiresQuickLinkTemplateProperties[] = [];

  private template: any;

  private link: any;

  constructor(qlt: any, link?: any) {
    this.template = qlt.template;
    this.link = link;
    this.buildRequirePropertiesRecursive(this.template);
  }

  private buildRequirePropertiesRecursive = (arr: any, parent?: string) => {
    Object.keys(arr).forEach((node) => {
      if (arr[node] && typeof arr[node] === 'object') {
        this.buildRequirePropertiesRecursive(arr[node], node);
        if (arr[node].required) {
          this.requiredProperties.push({ parent: parent || '', node, value: arr[node] });
        }
      }
    });
  };

  public getRequiredProperties(): RequiresQuickLinkTemplateProperties[] {
    return this.requiredProperties || [];
  }

  public getValidationMap(): {} {
    return this.requiredProperties.reduce((value: {}, property: RequiresQuickLinkTemplateProperties) => {
      let isValid = false;
      if (this.link) {
        isValid = validateLinkForRequiredProperty(property, this.link);
      } else if ([ValueTypes.FIXED, ValueTypes.CHOOSE].includes(property.value.valueType)) {
        isValid = true;
      }
      value[buildValidationMapKey(property)] = isValid;
      return value;
    }, {});
  }
}
